import axios from 'axios';

const OnboardingService = {
  complete: (payload) => axios.post('/onboarding/complete', payload),
};

export default OnboardingService;

